import {useKeycloak} from "@react-keycloak/web";
import Button from "@mui/material/Button";
import {Typography} from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";

const PrivateRoute = ({children}) => {
    const {keycloak} = useKeycloak();

    const isLoggedIn = keycloak.authenticated;

    return isLoggedIn
        ? children
        : <Box>
            <Box sx={{marginTop: 4}}>
                <Typography variant="h4">Access Denied!</Typography>
            </Box>
            <Box sx={{marginTop: 4}}>
                <Typography variant="h5">You are not allowed to access this page.</Typography>
            </Box>
            <Box sx={{marginTop: 4}}>
                <Button sx={{margin: 1}} variant={"outlined"} onClick={() => keycloak.login()}>Login</Button>
            </Box>
        </Box>
};

export default PrivateRoute;
